import { render } from "./CreateReport.vue?vue&type=template&id=e4bd0bde&scoped=true&ts=true"
import script from "./CreateReport.vue?vue&type=script&lang=ts"
export * from "./CreateReport.vue?vue&type=script&lang=ts"

import "./CreateReport.vue?vue&type=style&index=0&id=e4bd0bde&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4bd0bde"]])

export default __exports__